import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserList } from '../../../../../common/models/user.model';
import { ApiResponse } from '../../../../../common/models/api-response.model';
import { Option } from '../../../../../common/models/option.model';
import { ENDPOINTS } from '../../../../../common/constants/endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class CollaboratorService {
  http = inject(HttpClient);

  getCollaborators(
    flowId: string,
    page: number,
    search: string
  ): Observable<ApiResponse<UserList>> {
    const url = ENDPOINTS.Application.Collaborator.getCollaborators.replace(
      '{flowId}',
      flowId
    );
    return this.http.get<ApiResponse<UserList>>(url, {
      params: { page, 'filters[search]': search },
    });
  }

  addCollaborators(
    flowId: string,
    collaborators: { added_user_ids: number[] }
  ) {
    const url = ENDPOINTS.Application.Collaborator.addCollaborators.replace(
      '{flowId}',
      flowId
    );
    return this.http.post<void>(url, collaborators);
  }

  removeCollaborators(flowId: string, collaboratorId: number) {
    const url = ENDPOINTS.Application.Collaborator.removeCollaborators
      .replace('{flowId}', flowId)
      .replace('{collaboratorId}', collaboratorId.toString());
    return this.http.delete<void>(url);
  }

  removeSelectedListFromLookupList(
    selectedList: Option[],
    lookupList: Option[]
  ): Option[] {
    if (selectedList.length) {
      return lookupList.filter(
        item =>
          !selectedList.some(
            card => card.value.toString() === item.value.toString()
          )
      );
    }
    return lookupList;
  }

  removeAddedListFromLookupList(
    addedList: Option[],
    lookupList: Option[]
  ): Option[] {
    if (addedList.length) {
      return lookupList.filter(
        item =>
          !addedList.some(
            card => card.value.toString() === item.value.toString()
          )
      );
    }
    return lookupList;
  }

  addRemovedListFromLookupList(
    name: string,
    removedList: Option[],
    lookupList: Option[]
  ): Option[] {
    if (removedList.length) {
      if (name.length >= 3) {
        const list = [
          ...lookupList,
          ...removedList.filter(item =>
            item.label.toLocaleLowerCase().includes(name.toLocaleLowerCase())
          ),
        ];
        return list;
      } else {
        return [...lookupList, ...removedList];
      }
    }
    return lookupList;
  }
}
